import React, { useEffect, useMemo, useState } from 'react';
import { fetchYieldSheet, yieldWrite } from '../services/api';
import { addTally, countingItems, formFromSheet, removeTally, setLive, usDate, yieldTotals } from './yieldSheetCalc';
import { GradedTable, YieldFlagNote } from './YieldSheetEditor';

/**
 * The admin portal's counting mode: tallies and live counts for one sheet, saved on every change.
 * Only the grade rows are written. Azure exit WS8.
 */

const startRows = (rows) => rows.map((r) => (r.tallyValues.reduce((a, b) => a + b, 0) === 0 ? { ...r, totalGraded: '' } : r));

export default function YieldSheetCounting({ id, name, date, live, onClose }) {
  const [form, setForm] = useState(null);
  const [yieldSheetId, setYieldSheetId] = useState(0);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchYieldSheet(id).then((data) => {
      const f = formFromSheet(data).form;
      setYieldSheetId(data.yieldSheet.yieldSheetId);
      setForm({ maleGradedRows: startRows(f.maleGradedRows), femaleGradedRows: startRows(f.femaleGradedRows) });
    }).catch((e) => setMessage({ text: e.message }));
  }, [id]);

  const totals = useMemo(() => (form ? yieldTotals(form.maleGradedRows, form.femaleGradedRows, 0) : null), [form]);

  const save = async (silent, current = form) => {
    if (!live) return;
    try {
      const r = await yieldWrite('yield_counts', { items: countingItems(current, yieldSheetId) });
      if (!silent) setMessage(r.ok ? { text: 'Saved', good: true } : { text: 'Could not save.' });
    } catch (e) { if (!silent) setMessage({ text: e.message }); }
  };

  const change = (field, rows) => {
    const next = { ...form, [field]: rows };
    setForm(next);
    save(true, next);
  };

  return (
    <div>
      <div className="page-header"><h2 style={{ fontSize: 16, fontWeight: 700, color: 'var(--navy)', margin: 0 }}>Yield Counting</h2></div>
      <YieldFlagNote live={live} />
      {message && <div className={`ys-note ${message.good ? 'ys-note-good' : 'ys-note-bad'}`}>{message.text}</div>}
      <div className="ys-count-head"><span>Crabber Name: <strong>{name}</strong></span><span>Date Received: <strong>{usDate(date)}</strong></span></div>
      {!form && !message && <div className="ys-status">Loading...</div>}
      {form && (
        <div className="card"><div className="card-body">
          <GradedTable title="Male" rows={form.maleGradedRows} total={totals.totalMaleYielded} field="maleGradedRows" locked={false}
            onTally={(f, i, v) => change(f, addTally(form[f], i, v))} onRemove={(f, i, v) => change(f, removeTally(form[f], i, v))} onLive={(f, i, v) => change(f, setLive(form[f], i, v))} />
          <GradedTable title="Female" rows={form.femaleGradedRows} total={totals.totalFemaleYielded} field="femaleGradedRows" locked={false}
            onTally={(f, i, v) => change(f, addTally(form[f], i, v))} onRemove={(f, i, v) => change(f, removeTally(form[f], i, v))} onLive={(f, i, v) => change(f, setLive(form[f], i, v))} />
        </div></div>
      )}
      <div className="ys-footer ys-count-foot">
        <button type="button" className="btn btn-outline" onClick={() => { if (window.confirm('Do you want to Close?')) onClose(); }}>Close</button>
        <button type="button" className="btn btn-primary" disabled={!live} onClick={() => save(false)}>Save</button>
      </div>
    </div>
  );
}